var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef } from "react";
import icons from "../../utils/Icons";
import PrimaryButton from "../Button/PrimaryButton";
// import ImageThumbnail from "../ImageThumbnail";
// import images from "../../utils/Images";
import { ToastContainer, toast } from "react-toastify";
import useAddNameToList from "../../hooks/useAddNameToList";
import Spinner from "../Spinner";
import useAddTimeLog from "../../hooks/useAddTimeLog";
import useFetchShipNames from "../../hooks/useFetchShipNames";
import useFetchHeaderNames from "../../hooks/useFetchHeaderNames";
import TimeSelector from "../TimeSelector";
var AddTimeLogs = function (_a) {
    var closeModal = _a.closeModal, positions = _a.positions, addLogHandle = _a.addLogHandle;
    var modalRef = useRef(null);
    var _b = React.useState(0), selectedPosition = _b[0], setSelectedPositions = _b[1];
    var _c = React.useState(""), dateSelected = _c[0], setDateSelected = _c[1];
    var _d = React.useState(""), startTime = _d[0], setStartTime = _d[1];
    var _e = React.useState(""), endTime = _e[0], setEndTime = _e[1];
    var _f = React.useState(""), shipName = _f[0], setShipName = _f[1];
    var _g = React.useState(""), headerName = _g[0], setHeaderName = _g[1];
    var _h = React.useState([]), shipSuggestions = _h[0], setShipSuggestions = _h[1];
    var _j = React.useState([]), headerSuggestions = _j[0], setHeaderSuggestions = _j[1];
    var _k = React.useState(false), showShipSuggestions = _k[0], setShowShipSuggestions = _k[1];
    var _l = React.useState(false), showHeaderSuggestions = _l[0], setShowHeaderSuggestions = _l[1];
    var _m = useAddTimeLog(), timeLogLoading = _m.loading, addTimeLog = _m.addTimeLog;
    var _o = useFetchShipNames(), shipNames = _o.shipNames, getShipNames = _o.getShipNames, error = _o.error;
    var _p = useFetchHeaderNames(), headerNames = _p.headerNames, getHeaderNames = _p.getHeaderNames, headerNameError = _p.error;
    var getShipNameOptions = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getShipNames()];
                case 1:
                    _a.sent();
                    if (error) {
                        toast.error(error);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getHeaderNameOptions = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getHeaderNames()];
                case 1:
                    _a.sent();
                    if (headerNameError) {
                        toast.error(headerNameError);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        getShipNameOptions();
        getHeaderNameOptions();
    }, []);
    useEffect(function () {
        if (shipNames.length > 0) {
            setShipSuggestions(shipNames);
        }
        if (headerNames.length > 0) {
            setHeaderSuggestions(headerNames);
        }
    }, [shipNames, headerNames]);
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (modalRef.current &&
                !modalRef.current.contains(event.target)) {
                closeModal();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [closeModal]);
    var closeModalHandle = function () {
        closeModal();
    };
    var addLogAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log("testing");
                    console.log({
                        selected_position: selectedPosition,
                        date: dateSelected,
                        start_time: startTime,
                        end_time: endTime,
                        ship_name: shipName,
                        header_name: headerName,
                    }, "payload checking");
                    if (selectedPosition === 0) {
                        toast.error("Please select a position");
                        return [2 /*return*/];
                    }
                    if (dateSelected == "") {
                        toast.error("Please select a date");
                        return [2 /*return*/];
                    }
                    if (startTime == "") {
                        toast.error("Please select a start time");
                        return [2 /*return*/];
                    }
                    if (endTime == "") {
                        toast.error("Please select an end time");
                        return [2 /*return*/];
                    }
                    if (shipName == "") {
                        toast.error("Please Enter Ship Name");
                        return [2 /*return*/];
                    }
                    if (headerName == "") {
                        toast.error("Please Enter Header Name");
                        return [2 /*return*/];
                    }
                    payload = {
                        selected_position: selectedPosition,
                        date: dateSelected,
                        start_time: startTime,
                        end_time: endTime,
                        ship_name: shipName,
                        header_name: headerName,
                        // user_id: 123,
                        isEdit: false,
                    };
                    return [4 /*yield*/, addTimeLog(payload)];
                case 1:
                    result = _a.sent();
                    if (result.status === "success") {
                        toast.success(result.message);
                        addLogHandle();
                    }
                    else if (result.status == "failed") {
                        toast.error(result.message);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleShipNameChange = function (value) {
        setShipName(value);
        setShowShipSuggestions(value.length > 0 &&
            !shipSuggestions.some(function (ship) { return ship.toLowerCase() === value.toLowerCase(); }));
    };
    var handleHeaderNameChange = function (value) {
        setHeaderName(value);
        setShowHeaderSuggestions(value.length > 0 &&
            !headerSuggestions.some(function (header) {
                return header.toLowerCase() === value.toLowerCase();
            }));
    };
    var selectSuggestion = function (suggestion) {
        setShipName(suggestion);
        setShowShipSuggestions(false);
    };
    var selectHeaderSuggestion = function (suggestion) {
        setHeaderName(suggestion);
        setShowHeaderSuggestions(false);
    };
    var loading = useAddNameToList().loading;
    var handleStartTimeChange = function (time) {
        if (endTime && time > endTime) {
            toast.error("Start time can not be after end time");
            setStartTime("");
            return;
        }
        setStartTime(time);
    };
    var handleEndTimeChange = function (time) {
        if (startTime && time < startTime) {
            toast.error("End time can not be before start time");
            setEndTime("");
            return;
        }
        setEndTime(time);
    };
    return (_jsxs("div", { ref: modalRef, className: "absolute flex-1 top-0 right-0 left-0 z-10 justify-center px-4 overflow-y-auto", children: [_jsx(ToastContainer, { position: "top-right" }), _jsxs("div", { className: "bg-white my-12 relative w-full lg:w-[40%] lg:mx-auto rounded-xl border-[#00000014] outline-none p-4 opacity-100 shadow-[0_8px_12px_0_rgba(47,43,67,0.2)] border-t-[1px] border-t-[rgba(47,43,67,0.1)]", children: [_jsx("button", { onClick: function () { return closeModalHandle(); }, className: "text-slate-700 absolute top-[12px] right-[12px]", children: _jsx("img", { src: icons.closeBlack, alt: "" }) }), _jsx("div", { className: "mt-2", children: _jsx("h3", { className: "text-left text-[18px] font-semibold", children: "Add Time Logs" }) }), _jsxs("div", { className: "my-4 ", children: [_jsx("label", { htmlFor: "email", className: "mb-3 text-[15px] font-[500]", children: "Position" }), _jsx("div", { className: "mt-2", children: _jsxs("select", { className: "w-full py-2 border border-[#00000014] outline-none rounded-md", onChange: function (e) {
                                        setSelectedPositions(e.target.value);
                                    }, defaultValue: selectedPosition, children: [_jsx("option", { value: 0, disabled: true, children: "Select Position" }), positions.map(function (position, index) {
                                            return (_jsx("option", { value: position.id, children: position.position }, index));
                                        })] }) })] }), _jsxs("div", { className: "my-4", children: [_jsx("label", { htmlFor: "date", className: "mb-3 text-[15px] font-[500]", children: "Date" }), _jsx("input", { type: "date", id: "date", className: "w-full py-2 border border-[#00000014] outline-none rounded-md", onClick: function (e) {
                                    var input = e.target;
                                    input.showPicker && input.showPicker();
                                }, value: dateSelected, onChange: function (e) { return setDateSelected(e.target.value); } })] }), _jsx("div", { className: "my-4", children: _jsx(TimeSelector, { label: "Start Time", onTimeChange: handleStartTimeChange, initialValue: startTime }) }), _jsx("div", { className: "my-4", children: _jsx(TimeSelector, { label: "End Time", onTimeChange: handleEndTimeChange, initialValue: endTime }) }), _jsxs("div", { className: "my-4", children: [_jsx("label", { htmlFor: "ship-name", className: "mb-3 text-[15px] font-[500]", children: "Ship Name" }), _jsx("input", { type: "text", value: shipName, onChange: function (e) { return handleShipNameChange(e.target.value); }, onFocus: function () { return setShowShipSuggestions(true); }, onBlur: function () {
                                    return setTimeout(function () { return setShowShipSuggestions(false); }, 200);
                                }, placeholder: "Enter ship name or select from suggestions", className: "w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors", required: true }), showShipSuggestions && (_jsx("div", { className: "absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto", children: shipSuggestions
                                    .filter(function (ship) {
                                    return ship
                                        .toLowerCase()
                                        .includes(shipName.toLowerCase());
                                })
                                    .map(function (ship, index) { return (_jsx("button", { type: "button", onClick: function () { return selectSuggestion(ship); }, className: "w-full px-4 py-2 text-left hover:bg-blue-50 transition-colors border-b border-gray-100 last:border-b-0", children: ship }, ship + index)); }) }))] }), _jsxs("div", { className: "my-4", children: [_jsx("label", { htmlFor: "header-name", className: "mb-3 text-[15px] font-[500]", children: "Header Name" }), _jsx("input", { id: "header-name", type: "text", value: headerName, onChange: function (e) { return handleHeaderNameChange(e.target.value); }, onFocus: function () { return setShowHeaderSuggestions(true); }, onBlur: function () {
                                    return setTimeout(function () { return setShowHeaderSuggestions(false); }, 200);
                                }, placeholder: "Enter header name or select from suggestions", className: "w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors", required: true }), showHeaderSuggestions && (_jsx("div", { className: "absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto", children: headerSuggestions
                                    .filter(function (header) {
                                    return header
                                        .toLowerCase()
                                        .includes(headerName.toLowerCase());
                                })
                                    .map(function (header, index) { return (_jsx("button", { type: "button", onClick: function () {
                                        return selectHeaderSuggestion(header);
                                    }, className: "w-full px-4 py-2 text-left hover:bg-blue-50 transition-colors border-b border-gray-100 last:border-b-0", children: header }, header + index)); }) }))] }), _jsx("div", { className: "my-4", children: loading ? (_jsx(Spinner, {})) : (_jsx(PrimaryButton, { title: "Add", classes: "bg-[#5898FD] text-white w-full py-2", clickHandle: function () { return addLogAction(); } })) })] })] }));
};
export default AddTimeLogs;
